<template>
  <div class="form-section-separator">
    <a-icon v-if="icon" :type="icon" />
    <span class="font-weight-bold font-size-20">{{ title }}</span>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
.form-section-separator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  background-color: #f0f2f4;
  padding: 10px 20px;
  border-radius: 5px;
}
</style>
